var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud2Type(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "65px",
    viewBox: "0 0 78.0 65.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1680,0 L1680,1080 L0,1080 L0,0 L1680,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i1",
    x: "-71.4285714%",
    y: "-85.7142857%",
    filterUnits: "userSpaceOnUse",
    width: "195.238095%",
    height: "214.285714%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    stdDeviation: 5,
    dx: 0,
    dy: 0,
    floodColor: "rgba(2, 255, 225, 0.304128)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9999713,10.3625967 C14.0267508,10.3625967 16.8732077,11.4739743 19.0128455,13.489418 L17.4105004,14.998918 C15.6981239,13.3858705 13.4211767,12.4976557 10.9998564,12.4976557 C8.57853617,12.4976557 6.30204834,13.3869525 4.58978676,15 L2.98709706,13.4904459 C5.12684976,11.4739743 7.97336403,10.3625967 10.9999713,10.3625967 Z M5.66580786,0 L7.268153,1.50949997 L5.23642163,3.42350612 L7.268153,5.33751226 L5.66580786,6.84701223 L3.6340765,4.93300609 L1.60234513,6.84701223 L0,5.33751226 L2.03196107,3.42350612 L0,1.50949997 L1.60234513,0 L3.6340765,1.91400615 L5.66580786,0 Z M20.3976549,0 L22,1.50949997 L19.9680389,3.42350612 L21.9997703,5.33751226 L20.3974252,6.84701223 L18.3656938,4.93300609 L16.3339624,6.84701223 L14.7316173,5.33751226 L16.7633487,3.42350612 L14.7316173,1.50949997 L16.3339624,0 L18.3656938,1.91400615 L20.3976549,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i3",
    x: "-44.1176471%",
    y: "-55.5555556%",
    filterUnits: "userSpaceOnUse",
    width: "158.823529%",
    height: "174.074074%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    stdDeviation: 5,
    dx: 0,
    dy: 0,
    floodColor: "rgba(2, 255, 225, 0.304128)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67818046,0.720491809 C9.83344538,1.24652127 9.52291553,1.80289857 8.98466378,1.95463784 C4.8960207,3.10785626 2.04949704,6.83052626 2.04949704,10.9881821 C2.04949704,16.177665 6.36586201,20.3960166 11.6759225,20.3960166 L25.2978321,20.3960166 C25.8567859,20.3960166 26.3225806,20.8411185 26.3225806,21.3974958 C26.3225806,21.9538731 25.8567859,22.4090909 25.2978321,22.4090909 L11.6759225,22.4090909 C5.23760354,22.4090909 0,17.2904197 0,10.9982981 C0,5.95043851 3.45723238,1.44884029 8.41535905,0.0427230876 C8.96396179,-0.11913213 9.52291553,0.194462354 9.67818046,0.720491809 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1788357,0 C16.2349897,0 20.0006774,1.9309354 22.2725385,5.17250571 C22.5941262,5.62272381 22.4696406,6.2430243 22.0028198,6.5431697 C21.5359991,6.85331995 20.9031975,6.73326179 20.5816099,6.28304369 C18.6935791,3.5817351 15.5503192,1.97095479 12.1788357,1.97095479 C6.69109797,1.97095479 2.05401147,6.63321332 2.05401147,12.1458838 C2.04363768,12.6961504 1.58719068,13.1363636 1.02700574,13.1363636 C0.466820789,13.1363636 0,12.6961504 0,12.1458838 C0,5.56269473 5.58110188,0 12.1788357,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.94110892,0 C8.04065438,0 11.516356,3.70909091 11.6054765,8.12757079 C11.6153788,8.17824143 11.6153788,8.22891207 11.6054765,8.27958271 L11.6054765,8.28971684 C11.598875,8.35052161 11.5922735,8.41132638 11.5798039,8.46912844 L11.5559651,8.55320417 C11.4272354,8.96870343 11.0608509,9.27272727 10.6350527,9.27272727 L10.6053459,9.27272727 C10.1102317,9.26259314 9.70423804,8.89776453 9.65472662,8.41132638 L9.64482434,8.29985097 C9.64482434,4.94545455 6.97120773,2.00655738 3.93120663,2.00655738 L0.980326088,2.00655738 C0.445602767,2.00655738 0,1.56065574 0,1.00327869 C0,0.456035768 0.435700483,0 0.980326088,0 L3.94110892,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9691816,0.0118143438 C27.1901893,0.946710272 30.9677419,5.45859932 30.9677419,10.7326318 C30.9575047,16.7484838 26.043615,21.6363636 19.9933884,21.6363636 L1.01348974,21.6363636 C0.460677153,21.6363636 0,21.1892395 0,20.6303343 C0,20.0714291 0.450439883,19.624305 1.01348974,19.624305 L19.9933884,19.624305 C24.9277526,19.624305 28.9509997,15.6408354 28.9509997,10.7326318 C28.9509997,6.43414289 25.8593442,2.75553065 21.6108771,1.99338723 C21.0580645,1.89176811 20.6997601,1.37351059 20.7918955,0.824767325 C20.8942682,0.276024063 21.4266062,-0.0694809542 21.9691816,0.0118143438 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-308.0 -587.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(323.0 602.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.0 12.0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 22,0 22,15 0,15 0,0",
    stroke: "none",
    fill: "#55BAB0"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#i3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 11.590909090909092)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,1.47104551e-15 26.3225806,1.47104551e-15 26.3225806,22.4090909 0,22.4090909 0,1.47104551e-15",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.741935483870966 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 22.4516129,0 22.4516129,13.1363636 0,13.1363636 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.87096774193548 4.636363636363637)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 11.6129032,0 11.6129032,9.27272727 0,9.27272727 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.032258064516128 12.36363636363636)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,1.77635684e-15 30.9677419,1.77635684e-15 30.9677419,21.6363636 0,21.6363636 0,1.77635684e-15",
    stroke: "none",
    fill: "#55BAB0"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud2Type);
export default __webpack_public_path__ + "static/media/cloud-2-type.19d009f0d154d492a4fdb5952e450fd8.svg";
export { ForwardRef as ReactComponent };